import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { Box, Grid, KeyValue, SectionHeader } from 'web-library';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles()((theme) =>
({
  container: {
    paddingBottom: theme.spacing(1),
  },
}));

export interface PsleExamDetailProps {
  examLevel: string;
  year: number;
  examCentreCity: string | null;
  examCentreCountry: string | null;
}

const PsleExamDetail = ({
  examLevel,
  year,
  examCentreCity,
  examCentreCountry,
}: PsleExamDetailProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.container}>
      <SectionHeader title={t('components->>ExamDetail.Exam Details')} />
      <Grid container spacing={2}>
        <Grid md={12} xs={12}>
          <KeyValue
            keyText={t('components->>ExamDetail.Exam Level')}
            valueText={t('components->>{{examLevel}}', { examLevel })}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid md={12} xs={12}>
          <KeyValue keyText={t('components->>ExamDetail.ExamYear')} valueText={year.toString()} />
        </Grid>
      </Grid>
      {examCentreCity && examCentreCountry && (
        <Grid md={12} xs={12}>
          <KeyValue
            keyText={t('components->>ExamDetail.CityCountry')}
            valueText={`${examCentreCity} / ${examCentreCountry}`}
          />
        </Grid>
      )}
    </Box>
  );
};

export default PsleExamDetail;
